import { useIntegrations } from '@/core/hooks/use-integrations'
import { useRouting } from '@/core/hooks/useRouting'
import { useEffect, useMemo } from 'react'
import Microsoft365IntegrationIcon from '@/assets/images/microsoft-integration.svg?react'
import GoogleIntegrationIcon from '@/assets/images/google-workspace-fd.svg?react'
import CrowdstrikeIntegrationIcon from '@/assets/images/crowdstrike-integration.svg?react'
import { IntegrationsStore } from '@/core/store/Integrations'

const useIntegrationRoute = () => {
    const { navigate, navigateTo, ROUTES } = useRouting()
    const { hasEnabledIntegrations } = useIntegrations()
    const { providers } = IntegrationsStore.useStore()
    const msProvider = IntegrationsStore.getProviderByType('microsoft')
    const googleProvider = IntegrationsStore.getProviderByType('google')
    const googleFraudDefenseProvider = IntegrationsStore.getProviderByType(
        'google_fraud_defense'
    )
    const msFraudDefenseProvider =
        IntegrationsStore.getProviderByType('ms_fraud_defense')
    const crowdstrikeProvider =
        IntegrationsStore.getProviderByType('crowdstrike')

    const isMsProviderIntegrated =
        IntegrationsStore.getActiveAndBrokenIntegrationsByType('microsoft')
            .length > 0

    const isGoogleProviderIntegrated =
        IntegrationsStore.getActiveAndBrokenIntegrationsByType('google')
            .length > 0

    useEffect(() => {
        if (!hasEnabledIntegrations) {
            navigateTo({
                path: ROUTES.settings.path,
                event: {
                    name: 'SEM::navigate_to_settings_page',
                    params: {
                        origin: 'integrations_page',
                    },
                },
            })
        }
    }, [hasEnabledIntegrations])

    useEffect(() => {
        if (!hasEnabledIntegrations) {
            navigate(ROUTES.settings.path)
        }
    }, [navigate, hasEnabledIntegrations, ROUTES.settings.path])

    const integrationsProvidersData = useMemo(
        () => [
            {
                name: 'microsoft',
                description:
                    'Connect your M365 accounts to detect misconfigurations and security gaps, and to protect your organization from financial attacks.',
                icon: <Microsoft365IntegrationIcon />,
                provider: isMsProviderIntegrated
                    ? msProvider
                    : msFraudDefenseProvider,
            },
            {
                name: 'google',
                description:
                    'Connect your Google Workspaces to detect misconfigurations and security gaps, and to protect your organization from financial attacks.',
                icon: <GoogleIntegrationIcon />,
                provider: isGoogleProviderIntegrated
                    ? googleProvider
                    : googleFraudDefenseProvider,
            },
            {
                name: 'crowdstrike',
                description:
                    'Connect your CrowdStrike account to get insight into your devices and monitor your endpoint security solution coverage.',
                icon: <CrowdstrikeIntegrationIcon />,
                provider: crowdstrikeProvider,
            },
        ],
        [providers]
    )

    return {
        integrationsProvidersData,
    }
}

export default useIntegrationRoute
